export enum BarcodeType {
    QRCODE,
    BARCODE,
}
